import React from 'react'

const Test = () =>
  <span>
    TEST components
  </span>

export default Test


// WEBPACK FOOTER //
// ./src/config/custom-components/Test.js